module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.orderReport.selectAuth) ? _c('div', {
    attrs: {
      "id": "orderReports"
    }
  }, [_vm._v("\n    密码：xora\n     "), _c('iframe', {
    attrs: {
      "id": "mainIframe",
      "name": "mainIframe",
      "width": "100%",
      "height": "1000px",
      "src": "https://me.bdp.cn/share/index.html?shareId=sdo_70062d3c866ab1c2f420241bee792e48",
      "frameborder": "0",
      "scrolling": "auto"
    }
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-65bb0c3a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/finreport/bdpReport.vue
// module id = 1695
// module chunks = 0